import { render, staticRenderFns } from "./Webhooks_MD.vue?vue&type=template&id=37ab96a8&scoped=true"
import script from "./Webhooks_MD.vue?vue&type=script&lang=js"
export * from "./Webhooks_MD.vue?vue&type=script&lang=js"
import style0 from "./Webhooks_MD.vue?vue&type=style&index=0&id=37ab96a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ab96a8",
  null
  
)

export default component.exports